import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RelatedProductsComponentDef } from '@df/catalog-ui/related-products/related-products.component.def';
import { DfModuleGtmModule } from '@df/module-gtm/df-module-gtm.module';
import { DfUiCarouselModule } from '@df/ui-carousel/carousel.module';
import { ProductComponent } from '../product/product.component';
let uid = 0;
@Component({
    imports: [DfUiCarouselModule, CommonModule, ProductComponent, DfModuleGtmModule],
    selector: 'related-products',
    templateUrl: './related-products.html',
    styleUrl: './related-products.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RelatedProductsComponent extends RelatedProductsComponentDef {
    getEnginesName(): string {
        return this.options.engines.toString().replace(',', '-');
    }

    protected uid = uid++;

    get pcSlides(): number {
        const slides = [1.15, 2.15, 4.25, 5.2][this.client.sizeId];
        return Math.min(slides, this.limit);
    }

    get pcSlidesCeil(): number {
        return Math.ceil(this.pcSlides);
    }

    get pcGutter(): string {
        return [16, 10, 20, 20][this.client.sizeId] + 'px';
    }
}
